import React from "react";

export function StatusMessage({status,statusMessage}: {status: "success" | "uploading" | "fail",statusMessage: string}
) {

  if (status === 'success') {
    return <p className = "italic">{statusMessage}</p>;
  } else if (status === 'fail') {
    return <p className = "italic">{statusMessage}  </p>;
  } else if (status === 'uploading') {
    return <p className = "italic animation-spin">{statusMessage}</p>;
  } else {
    return null;
  }

}
